export default class LMT {
	constructor() {
		this.opacity = {
			minValue: 0,
			maxValue: 100,
		};
	}

	async addBlock(blockNum = lutify.blocks.length, data) {
		UI.createAdjustmentBlockTemplate("LMT", blockNum, data);
		let $element = $(UI.getAdjustmentBlock(blockNum));

		blocks.add({
			name: 'LMT',
			passes: [this.addPass()],
			blockNum,
			blendingMode: 0,
			blendingModeName: "Normal",
			opacity: 100,
		});

		$element.find(".expand_options").trigger("click", [false]);
	}

	async applyLMT(LUT) {
		let loadedLUTs = await luts.load(LUT);
		let pass = gpu.createLUTPass(loadedLUTs[0].texture);
		pass.uid = lutify.getActiveBlock().passes[0].uid;

		let passIndex = gpu.getPassIndexById(pass.uid);
		lutify.getActiveBlock().passes[0] = pass;
		gpu.composer.passes[passIndex] = lutify.getActiveBlock().passes[0];

		gpu.render();
	}

	addPass() {
		let renderPass = gpu.createRenderPass();
		gpu.addPassToComposer(renderPass, "toMiddle");
		return renderPass;
	}
}
